module.exports = __webpack_public_path__ + "static/media/portrait.2aedaba2.jpg";